import React, { useContext, useState } from 'react';


import Modal from 'components/modal';
import Button from 'components/button';
import Spacer from 'components/spacer';

import LocaleContext from 'contexts/locale-context';

import './index.css';

let cb = null;
let cbErr = null;

const withConfirm = () => Component => (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState(null);
    const [message2, setMessage2] = useState(null);
    const [renderComponent, setRenderComponent] = useState(null);
    const [title, setTitle] = useState(null);
    const [padTitle, setPadTitle] = useState(true);

    const { translations } = useContext(LocaleContext);
    const jsTranslations = translations.js;

    const openConfirm = ({ message, message2, renderComponent, padTitle = true, title }, done, error) => new Promise(resolve => {
        setIsOpen(true);
        setMessage(message)
        setMessage2(message2)
        setRenderComponent(renderComponent)
        setTitle(title)
        setPadTitle(padTitle);
        cb = done || null;
        cbErr = error;
    })

    const closeConfirm = () => {
        if (cbErr) cbErr();
        setIsOpen(false);
    }

    const onButton = (resp) => {
        if (resp === 'no') {
            if (cbErr) cbErr();
        }
        if (cb) cb(resp);
        setIsOpen(false);
    }

    const renderFooter = () => {
        return (
            <>
                <Button
                    btnType='none'
                    onClick={() => onButton('no')}
                >
                    {jsTranslations.cancel}
                </Button>
                <Button
                    onClick={() => onButton('yes')}
                >
                    {jsTranslations.confirm}
                </Button>
            </>
        );
    }

    return (
        <div className='withconfirm'>
            <Component
                {...props}
                openConfirm={openConfirm}
                closeConfirm={closeConfirm}
            />
            <Modal
                isOpen={isOpen}
                onRequestClose={closeConfirm}
                renderFooter={renderFooter}
            >
                <div className='withconfirm__modal'>
                    {title &&
                        <>
                            <h3 className='withconfirm__modal__text withconfirm__modal__title'>
                                {title}
                            </h3>
                            {(!!message || !!message2 || !!renderComponent) && padTitle && <Spacer size='xl'/>}
                        </>
                    }

                    {message &&
                        <>
                            <p className='withconfirm__modal__text'>{message}</p>
                            {!!message2 || !!renderComponent && <Spacer size='xs'/>}
                        </>
                    }

                    {!!renderComponent && renderComponent}

                    {message2 &&
                        <>
                            <p className='withconfirm__modal__text'>{message2}</p>
                            <Spacer size='xs'/>
                        </>
                    }
                    <Spacer size='l'/>
                </div>
            </Modal>
        </div>
    )
};

export default withConfirm;